import { render, staticRenderFns } from "./doctorHome.vue?vue&type=template&id=e1d5bc38&scoped=true"
import script from "./doctorHome.vue?vue&type=script&lang=js"
export * from "./doctorHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d5bc38",
  null
  
)

export default component.exports